import '../../../filtersGrid.scss';
import React, { useState, useEffect, useContext } from 'react';
import Modal from 'react-modal';
import { useMediaQuery } from '@mui/material';
import SearchButton from '../../../../components/SearchButton/SearchButton';
import DepositosModal from '../../../depositos/depositosModal/depositosModal';
import MarcasModal from '../../../marcas/marcasModal/marcasModal';
import RamosModal from '../../../ramos/ramosModal/ramosModal';
import RubrosModal from '../../../rubros/rubrosModal/rubrosModal';
import SubrubrosModal from '../../../subrubros/subrubrosModal/subrubrosModal';
import { DarkModeContext } from '../../../../context/darkModeContext';

Modal.setAppElement('#root');

const FiltersGrid = ({
  searchInputRef,
  searchTerm,
  setSearchTerm,
  onSearch,
  onClose,
  setSearchIDDepo,
  setSearchDescDepo,
  setSearchIDMar,
  setSearchDescMar,
  setSearchIDRam,
  setSearchDescRam,
  setSearchIDRub,
  setSearchDescRub,
  setSearchIDSubr,
  setSearchDescSubr,
  searchIDDepo,
  searchIDRam,
  searchIDRub,
  searchDescDepo,
  selectRef,
  selectStockRef,
  selectOrderByRef,
  selectOrderRef,
  searchDes,
  searchStock,
  selectOrderBy,
  selectOrder,
  handleDesChange,
  handleClearDes,
  handleStockChange,
  handleClearStock,
  handleOrderByChange,
  handleClearOrderBy,
  handleOrderChange,
  handleClearOrder,
  idSelectorDepo,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { darkMode } = useContext(DarkModeContext);

  const isSmallScreen = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    if (!isSmallScreen) {
      setIsModalOpen(false); // Cierra el modal al cambiar a pantallas grandes
    }
  }, [isSmallScreen]);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleClearFilters = () => {
    setSearchTerm?.("");
    setSearchIDDepo?.("");
    setSearchDescDepo?.("");
    setSearchIDMar?.("");
    setSearchDescMar?.("");
    setSearchIDMar?.("");
    setSearchDescMar?.("");
    setSearchIDRam?.("");
    setSearchDescRam?.("");
    setSearchIDRub?.("");
    setSearchDescRub?.("");
    setSearchIDSubr?.("");
    setSearchDescSubr?.("");
    handleClearDes();
    handleClearStock();
    handleClearOrderBy();
    handleClearOrder();
  };
  console.log("filtros renderizados", {
    searchIDDepo,
    searchDescDepo,
    idSelectorDepo
  });
  return (
    <div className={`filterContainer ${darkMode ? "dark" : ""}`}>
      {isSmallScreen ? (
        <>
          <button className="filterButton" onClick={handleOpenModal}>
            Filtros De Búsqueda
          </button>

          <Modal
            isOpen={isModalOpen}
            onRequestClose={handleCloseModal}
            contentLabel="Seleccionar Filtros"
            className={`modalScreen ${darkMode ? "dark" : ""}`}
            overlayClassName={`overlayScreen ${darkMode ? "dark" : ""}`}
          >
            <h2>Filtros de Búsqueda</h2>
            <div className="modalContent">

              <SearchButton
                searchInputRef={searchInputRef}
                searchTerm={searchTerm} // Muestra el valor del filtro actual
                onSearch={onSearch}
                onChange={setSearchTerm}
                onClose={() => {
                  onClose();
                }}
                tipo={0}
              />
              {!idSelectorDepo && (
                <DepositosModal
                  handleChange={(id) => setSearchIDDepo(id)}
                  handleDescChange={(desc) => setSearchDescDepo(desc)}
                  descSelected={searchDescDepo}
                />
              )}
              <RamosModal
                handleChange={(id) => setSearchIDRam(id)}
                handleDescChange={(desc) => setSearchDescRam(desc)}
                handleRubChange={(id) => setSearchIDRub(id)}
                handleSubrChange={(id) => setSearchIDSubr(id)}
              />
              <SearchButton
                selectRef={selectRef}
                handleOptionChange={handleDesChange}
                handleClearOption={handleClearDes}
                searchOption={searchDes}
                tipo={2}
                defaultOption='Es Destacado?'
              />
              <SearchButton
                selectRef={selectStockRef}
                handleOptionChange={handleStockChange}
                handleClearOption={handleClearStock}
                tipo={2}
                searchOption={searchStock}
                defaultOption='Tipo de Stock'
                options={[
                  { value: "con_stock", label: "Con Existencia" },
                  { value: "sin_stock", label: "Sin Exitencia" },
                ]}
              />
              <SearchButton
                selectRef={selectStockRef}
                handleOptionChange={handleOrderByChange}
                handleClearOption={handleClearOrderBy}
                tipo={2}
                searchOption={selectOrderBy}
                defaultOption=''
                options={[
                  { value: "art_codigo", label: "Codigo" },
                  { value: "art_descripcion", label: "Descripcion" },
                  { value: "ade_cantidadexi", label: "Cantidad" },
                ]}
              />
              <SearchButton
                selectRef={selectOrderRef}
                handleOptionChange={handleOrderChange}
                handleClearOption={handleClearOrder}
                tipo={2}
                searchOption={selectOrder}
                defaultOption='Forma de Orden'
                options={[
                  { value: "ASC", label: "Ascedente" },
                  { value: "DESC", label: "Descendente" },
                ]}
              />

              <MarcasModal
                handleChange={(id) => setSearchIDMar(id)}
                handleDescChange={(desc) => setSearchDescMar(desc)}
              />

              <RamosModal
                handleChange={(id) => setSearchIDRam(id)}
                handleDescChange={(desc) => setSearchDescRam(desc)}
                handleRubChange={(id) => setSearchIDRub(id)}
                handleSubrChange={(id) => setSearchIDSubr(id)}
              />

              {searchIDRam && (
                <RubrosModal
                  handleChange={(id) => setSearchIDRub(id)}
                  handleDescChange={(desc) => setSearchDescRub(desc)}
                  handleSubrChange={(id) => setSearchIDSubr(id)}
                  idSelectorRam={searchIDRam} />

              )}

              {searchIDRam && searchIDRub && (
                <SubrubrosModal
                  handleChange={(id) => setSearchIDSubr(id)}
                  handleDescChange={(desc) => setSearchDescSubr(desc)}
                  idSelectorRam={searchIDRam}
                  idSelectorRub={searchIDRub} />

              )}

            </div>
            <div className="filtersActions">
              <button
                type="button"
                className="clearFiltersButton"
                onClick={handleClearFilters}
              >
                Limpiar filtros
              </button>
            </div>
            <button className="modalCloseButton" onClick={handleCloseModal}>
              ❌
            </button>
          </Modal>
        </>
      ) : (
        <div className="searchContainer">
          <SearchButton
            searchInputRef={searchInputRef}
            searchTerm={searchTerm}
            onSearch={onSearch}
            onChange={setSearchTerm}
            onClose={() => {
              onClose();
            }}
            tipo={0}
          />
          {!idSelectorDepo && (
            <DepositosModal
              handleChange={(id) => setSearchIDDepo(id)}
              handleDescChange={(desc) => setSearchDescDepo(desc)}
              descSelected={searchDescDepo}
            >

          </DepositosModal>
          )}
          <SearchButton
            selectRef={selectStockRef}
            handleOptionChange={handleStockChange}
            handleClearOption={handleClearStock}
            tipo={2}
            searchOption={searchStock}
            defaultOption='Tipo de Stock'
            options={[
              { value: "con_stock", label: "Con Existencia" },
              { value: "sin_stock", label: "Sin Exitencia" },
            ]}
          />
          <MarcasModal
            handleChange={(id) => setSearchIDMar(id)}
            handleDescChange={(desc) => setSearchDescMar(desc)}
          />

          <RamosModal
            handleChange={(id) => setSearchIDRam(id)}
            handleDescChange={(desc) => setSearchDescRam(desc)}
            handleRubChange={(id) => setSearchIDRub(id)}
            handleSubrChange={(id) => setSearchIDSubr(id)}
          />

          {searchIDRam && (
            <RubrosModal
              handleChange={(id) => setSearchIDRub(id)}
              handleDescChange={(desc) => setSearchDescRub(desc)}
              handleSubrChange={(id) => setSearchIDSubr(id)}
              idSelectorRam={searchIDRam} />

          )}

          {searchIDRam && searchIDRub && (
            <SubrubrosModal
              handleChange={(id) => setSearchIDSubr(id)}
              handleDescChange={(desc) => setSearchDescSubr(desc)}
              idSelectorRam={searchIDRam}
              idSelectorRub={searchIDRub} />

          )}

          <SearchButton
            selectRef={selectOrderByRef}
            handleOptionChange={handleOrderByChange}
            handleClearOption={handleClearOrderBy}
            tipo={2}
            searchOption={selectOrderBy}
            defaultOption='Ordernar Por'
            options={[
              { value: "art_codigo", label: "Codigo" },
              { value: "art_descripcion", label: "Descripcion" },
              { value: "ade_cantidadexi", label: "Cantidad" },
            ]}
          />
          <SearchButton
            selectRef={selectOrderRef}
            handleOptionChange={handleOrderChange}
            handleClearOption={handleClearOrder}
            tipo={2}
            searchOption={selectOrder}
            defaultOption='Forma de Orden'
            options={[
              { value: "ASC", label: "Ascedente" },
              { value: "DESC", label: "Descendente" },
            ]}
          />

          <div className="filtersActions">
            <button
              type="button"
              className="clearFiltersButton"
              onClick={handleClearFilters}
            >
              Limpiar filtros
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FiltersGrid;
